import styled from "styled-components";

export const InputLabel = styled.span`
  color: #9fa2b4;
  font-weight: 700;
  font-size: 14px;
`;

export const Title = styled.span`
  font-weight: 700;
  font-size: 28px;
  color: black;
`;

export const TotalTitle = styled.span`
  font-weight: 700;
  font-size: 20px;
  color: black;
`;

export const Subtitle = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #9fa2b4;
`;
